import BusinessIcon from "@mui/icons-material/Business"
import DashboardCreationWizardMUI from "components/dashboard/create.wizard"
import DashboardEdit from "components/dashboard/edit"
import DashboardList from "components/dashboard/list"
import DashboardShow from "components/dashboard/view"

const options = {
    list: DashboardList,
    create: DashboardCreationWizardMUI,
    edit: DashboardEdit,
    show: DashboardShow,
    icon: BusinessIcon,
    options: { label: 'resources.dashboards.name' },
}

export default options
